import { BookingState, TenantType } from '@xeetr/types/enums'

export interface BookingStateOption {
  label: string
  value: Lowercase<Exclude<BookingState, 'EVENT' | 'HOLIDAY'>> | 'all' | 'active'
}

export const BOOKING_STATES: BookingStateOption[] = [
  { label: 'Alle Reservierungen', value: 'all' },
  { label: 'Aktive Reservierungen', value: 'active' },
  { label: 'Offene Reservierungen', value: 'open' },
  { label: 'Bestätigte Reservierungen', value: 'accepted' },
  { label: 'Eingecheckte Reservierungen', value: 'checkedin' },
  { label: 'Ausgecheckte Reservierungen', value: 'checkedout' },
  { label: 'Stornierte Reservierungen', value: 'canceled' },
  { label: 'Abgelehnte Reservierungen', value: 'declined' },
]

export const ABSENCE_STATE: BookingStateOption = {
  label: 'Abwesenheiten',
  value: 'absence',
}

export const getBookingStates = (tenantType?: TenantType): BookingStateOption[] => {
  if (tenantType === TenantType.SERVICE) {
    return [...BOOKING_STATES, ABSENCE_STATE]
  }
  return BOOKING_STATES
}
